import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { StatsTableComponent } from './components/stats-table/stats-table.component';
import { DesignAngularKitModule } from 'design-angular-kit';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { StatsTableEntityCompressComponent } from './components/stats-table-entity-compress/stats-table-entity-compress.component';
import { StatsTableEntityExplodedComponent } from "./components/stats-table-entity-exploded/stats-table-entity-exploded.component";
import { StatsTableEntityManageComponent } from './components/stats-table-entity-manage/stats-table-entity-manage.component';
import { StatsTableEntityExplodedManageComponent } from './components/stats-table-entity-exploded-manage/stats-table-entity-exploded-manage.component';

@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [CommonModule, StatsTableComponent, DesignAngularKitModule, FormsModule, StatsTableEntityCompressComponent, StatsTableEntityExplodedComponent, StatsTableEntityManageComponent, StatsTableEntityExplodedManageComponent],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.scss'
})
export class StatisticsComponent {
  statistic: string = 'SETTING';

  constructor( public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.statistic = 'SETTING';
  }
}
